import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";


export class CreateAudienciaRequest  extends CreateKeyValueRequest{
  public id!: number;
  public sala!: string | null;
  public lugar!: string | null;
  public fecha!: string;
  public idTipoAudiencia!: number;
  public idEstadoAudiencia!: number;
  public idExpediente!: number;
  public asignadoA: number | null = null;
  public notificado: boolean | null = null;
  public linkVirtual: string | null = null;
  public resultadoAudiencia: string | null = null;
  public requiereActa: boolean | null = null;
  public actaGenerada: boolean | null = null;
  public actaUrl: string | null = null;


}
